import { Injectable }    from '@angular/core';
import { RequestOptionsArgs, Headers } from '@angular/http';
import { Interceptor, InterceptedRequest, InterceptedResponse } from 'ng2-interceptors';
import { WsseService }          from './wsse.service';

@Injectable()
export class AuthInterceptor implements Interceptor {

    constructor(private wsse: WsseService) { }

    public interceptBefore(request: InterceptedRequest): InterceptedRequest {
        let token: string = this.wsse.getHeader();
        if(token){
            request.options.headers.set('X-WSSE', token);
        }
        
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/security/auth-interceptor.service.ts